export function extractIteration(filename: string): number | null {
  // Videos: "rl-video-step-3000.mp4" → 3000
  // Checkpoints: "model_3000.pt" → 3000
  const match = filename.match(/(?:step-|model_|iter[_-]?|eval_)(\d+)/i);
  return match ? parseInt(match[1], 10) : null;
}

export function relativeTime(date: string): string {
  const now = Date.now();
  const then = new Date(date).getTime();
  const diffSec = Math.floor((now - then) / 1000);

  if (diffSec < 60) return 'just now';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 604800) return `${Math.floor(diffSec / 86400)}d ago`;

  return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'completed': return '#51cf66';
    case 'running': return '#42a5f5';
    case 'failed': return '#ff6b6b';
    case 'queued': return '#ffa726';
    case 'paused': return '#ffca28';
    default: return '#ffa726';
  }
}
